import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import CustomButton from '../../common/CustomButton';

import styles from './ManageTags.module.scss';

type ManageTagsProps = {
  openFilters: boolean;
  toggleFilters: (arg: boolean) => void;
  toggleManageDrawer: (arg: boolean) => void;
  tags: { name: string, color: string, id: number }[] | null;
}

const ManageTags: FC<ManageTagsProps> = ({
  openFilters = false,
  toggleFilters,
  toggleManageDrawer,
  tags,
}) => {

  return (
    <Box className={`${styles.customDrawer} ${openFilters && styles.isShown}`}>
      <Box className={styles.customDrawerHeader}>
        <Typography variant='h5Bold'>Filters</Typography>
        <CloseIcon className={styles.closeIcon} onClick={() => toggleFilters(false)} />
      </Box>
      <Box className={styles.customDrawerContent}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '40px' }}>
          <Typography variant="h9Bold">Show Tags</Typography>
          <CustomButton variant='outlined' onClick={() => toggleManageDrawer(true)}>
            Manage tags
          </CustomButton>
        </Box>
        {tags && tags.map(tag => (
          <Box
            key={tag.id}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              margin: '20px 0',
            }}
          >
            <Typography
              variant='h12Semibold'
              sx={{
                bgcolor: tag.color,
                padding: '5px 10px',
                borderRadius: '8px',
                height: '100%'
              }}
            >
              {tag.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default ManageTags;
